import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  ShadingType,
  VerticalAlign,
  HeightRule,
} from "docx";
import { saveAs } from "file-saver";

import { BylawsService } from 'src/app/services/bylaws.service';
import { ToastService } from 'src/app/toast/toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EncryptionService } from 'src/app/services/encryption.service';
import { SocietyMember } from 'src/app/classes/society';
import { SocietyService } from 'src/app/services/society.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { AadhaarValidator } from 'src/app/services/AadhaarValidator';
import { SweetAlertService } from 'src/app/toast/sweet-alert.service';
import { Modal } from 'bootstrap';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { AuditService } from 'src/app/services/audit.service';
import { LogIn } from 'lucide';

@Component({
  selector: 'app-bylaws2006',
  templateUrl: './bylaws2006.component.html',
  styleUrls: ['./bylaws2006.component.scss']
})
export class Bylaws2006Component implements OnInit {

  registrationForm!: FormGroup;
  addressForm: FormGroup;
  areaForm!: FormGroup;
  nameForm!: FormGroup;
  amendmentsList: any[] = [];
  detailsArray: { key: string; value: any }[] = [];
  objectiveForm: FormGroup = new FormGroup({});
  selectedFile: File | null = null;
  fileExtension: string = '';
  fileExtension2: string = '';
  base64Pdf: SafeResourceUrl = '';
  showAddMemberForm: boolean = false;
  preview: boolean = false;
  AmendmentType: any[] = [];
  societyMemberList: any[] = [];
  maritalStatus: boolean = false;
  societyMember: SocietyMember = new SocietyMember();
  memberForm: FormGroup = new FormGroup({});
  showHusbandWife: boolean = false;
  showFather: boolean = false;
  base64String: string = '';
  base64String2: string = '';
  societyId: number = 0;
  isSubmitMember: Boolean = false;
  isSubmitLaws: Boolean = false;
  isLoading: boolean = false;
  fileName: string = '';
  fees: boolean = false;
  aadhaarBase64: string = '';
  societyDetails: any;
  memberTypeList: any[] = [];
  castCategoryList: any[] = [];
  occuptionList: any[] = [];
  membershipTypeList: any[] = [];
  designationList: any[] = [];
  agree: boolean = false;
  spacecount: number = 0;
  amendmentForm!: FormGroup;
  selectedMember: any = null;
  aplicationDetailList: any
  firstnext: boolean = false;
  amendmentModel = {
    amendmentType: '',
    resolutionNo: '',
    resolutionDate: ''
  };

  bylawModel = {
    type: '',
    existingDetails: '',
    proposedChange: '',
    nocFile: null
  };
  uploadedFiles: any = {
    formIV: null,
    comparativeChart: null,
    auditedAccounts: null,
    resolutionGeneralBody: null,
    resolutionExecutive: null
  };
  byLawsId: any

  formData: any = {};
  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private byLawsService: BylawsService,
    private route: ActivatedRoute,
    private encryptionService: EncryptionService,
    private router: Router,
    private toastService: ToastService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private societyService: SocietyService,
    private configService: ConfigService,
    private alertService: SweetAlertService,
    private auditService: AuditService

  ) {
    this.amendmentForm = this.fb.group({
      iByLawsId: [null],
      iSocietyDetailsId: [null, Validators.required],
      iSocietyUserID: [null, Validators.required],
      iUserId: [null],
      IsCompleted: [false],

      FileFormIV: [null],
      FileNameFormIV: [null],

      FileComparativeChart: [null],
      FileNameComparativeChart: [null],

      FileAuditedAccount: [null],
      FileNameAuditedAccount: [null],

      FileGeneralBodyResolution: [null],
      FileNameGeneralBodyResolution: [null],

      FileExecutiveBodyResolution: [null],
      FileNameExecutiveBodyResolution: [null],

      Amendments: this.fb.array([]),
      ByLawsDetails: this.fb.array([])
    });
    this.addressForm = this.fb.group({
      existingAddress: [{ value: '', disabled: true }],
      existingDistrict: [{ value: '', disabled: true }],
      proposedAddress: ['', Validators.required],
      proposedDistrict: ['', Validators.required],
      purposeChange: ['', Validators.required],
      nocFile: [null, Validators.required]
    });
    this.areaForm = this.fb.group({
      existingArea: [{ value: '', disabled: true }],
      proposedAreaExtension: ['', Validators.required],
      purposeChange: ['', Validators.required]
    });

    let society: any = sessionStorage.getItem('societyDetail');
    this.societyDetails = JSON.parse(society);

    this.societyId = this.societyDetails.iSocietyId;

    this.amendmentForm.patchValue({
      iSocietyDetailsId: this.societyDetails.iSocietyDetailsId,
      iSocietyUserID: this.societyDetails.iSocietyUserID
    });
    this.nameForm = this.fb.group({
      existingDetails: [{ value: this.societyDetails?.sSocietyName, disabled: true }],
      proposedChange: ['', Validators.required],
      purposesChange: ['', Validators.required]
    });


  }

  ngOnInit(): void {

    this.initializeForm();

    this.fnObjectiveForm();
    this.fnMemberForm();
    this.getAmendmentType();

    this.getCastCategory();
    this.getOccuption();
    this.getDesignation();
    this.getMembershipType();
    this.getCastCategory();
    this.bindDistrict(0);
    this.getDropdownData();
    // this.amendmentsList = JSON.parse(localStorage.getItem("amendmentsList") || "[]");
    // this.bylawsList = JSON.parse(localStorage.getItem("bylawsList") || "[]");
    // this.uploadedFiles = JSON.parse(localStorage.getItem("uploadedFiles") || "{}");

    this.addressForm.patchValue({
      existingAddress: (this.societyDetails.sAddress1 || '') +
        (this.societyDetails.sAddress2 ? '\n' + this.societyDetails.sAddress2 : ''),
      existingDistrict: this.societyDetails.sdistrictname || ''
    });

    this.route.queryParams.subscribe(params => {
      this.byLawsId = params['byLawsId'];
      if (this.byLawsId) {
        this.getApplicationDetail(this.byLawsId)
      } else {
        this.getMemberList();
        this.restoreAmendmentsFromCache();
      }
    });

    this.getAllData('All');
  }

  getApplicationDetail(byLawsId: any) {

    let obj = {
      iByLawsId: byLawsId,
      iByLawsDetailId: byLawsId
    }

    this.byLawsService.getByLaws2006(byLawsId).subscribe((res: any) => {
      if (res?.status == 200 && res?.data) {
        this.aplicationDetailList = res?.data
        const amendmentsData: any = this.aplicationDetailList.amendments;

        // Ensure amendmentsList exists
        this.amendmentsList = [];

        const removedTypes = this.getRemovedAmendmentTypes();

        // Loop through and push formatted entries (skip permanently removed types e.g. Objectives)
        (amendmentsData || []).forEach((item: any) => {
          const amendmentType = item.amendmentType ?? item.AmendmentType;
          if (removedTypes.has(Number(amendmentType))) {
            return;
          }
          const newEntry = {
            amendmentType,
            resolutionNo: (item.resolutionNo ?? item.ResolutionNo)?.trim() || '',
            resolutionDate: item.resolutionDate ?? item.ResolutionDate,
            addedOn: new Date()
          };

          this.amendmentsList.push(newEntry);
        });

        this.mergeCachedAmendments();
        // Apply removed types again after cache merge
        this.amendmentsList = (this.amendmentsList || []).filter(
          (a: any) => !removedTypes.has(Number(a?.amendmentType))
        );
        this.cacheAmendmentsList();
        // this.bylawsList =    this.aplicationDetailList.by
        // this.uploadedFiles =    this.aplicationDetailList;
        // this.prefillAmendmentForm(  this.aplicationDetailList)
        this.prefillFiles(this.aplicationDetailList)
        let data = this.aplicationDetailList.byLawsDetailsResponse || [];
        const nameData = data.find((x: any) => x.sAmmendmentType == 1);
        const areaData = data.find((x: any) => x.sAmmendmentType == 4);
        const addressData = data.find((x: any) => x.sAmmendmentType == 5);
        if (areaData) {
          this.areaForm.patchValue({
            existingArea: areaData.sExistByLawsDetail || '',
            proposedAreaExtension: areaData.sNewByLawsDetail || '',
            purposeChange: areaData.reason || ''
          });
        }
        if (addressData) {
          this.addressForm.patchValue({
            existingAddress: addressData.sExistByLawsDetail || '',
            proposedAddress: addressData.sNewByLawsDetail.split('|')[0] || '',
            purposeChange: addressData.reason || '',
            proposedDistrict: addressData.sNewByLawsDetail ? (addressData.sNewByLawsDetail.split('|')[1] ? Number(addressData.sNewByLawsDetail.split('|')[1]) : '') : ''
          });
        }
        if (nameData) {
          this.nameForm.patchValue({
            //existingDetails: addressData.sExistByLawsDetail || '',
            proposedChange: nameData.sNewByLawsDetail || '',
            purposesChange: nameData.reason || ''
          });
        }

        // Manage Objectives: after refresh show only society defaults (not previously typed/new objectives)
        this.objectivesListCleared = false;
        if (this.existingObjectiveList?.length) {
          this.objectiveList = JSON.parse(
            JSON.stringify(this.existingObjectiveList)
          );
        } else {
          this.objectiveList = [];
        }

        // Do not restore type-2 proposed objectives from API into working lists
        const amendment = data.filter(
          (x: any) => !x.dObjectId && Number(x.sAmmendmentType) !== 2
        );
        const formattedList = amendment.map((item: any,index:any) => {
          return {
            type: item?.sAmmendmentType,

            existingDetails: item.sExistByLawsDetail
              ? item.sExistByLawsDetail.split('|').map((x: string, i: number) => ` ${x.trim()}`)
              : [],

            proposedChange: item.sNewByLawsDetail
              ? item.sNewByLawsDetail.split('|').map((x: string, i: number) => `${x.trim()}`)
              : [],

            purposesChange: item.reason
              ? [item.reason]
              : [],

            nocFile: null,

            // ✅ IMPORTANT: handle delete case
            dObjectId: item.dObjectId
              ? [item.dObjectId.toString()]
              : null
          };
        });
        this.bylawsList = [...this.bylawsList, ...formattedList];
        // Drop any leftover type-2 detail so refresh does not keep newly added objectives
        this.bylawsList = (this.bylawsList || []).filter(
          (b: any) => Number(b.type) !== 2
        );

        // Prefer draft memberList; if empty/null fall back to society members (do not wipe existing)
        const draftMembers = this.aplicationDetailList?.memberList;
        if (Array.isArray(draftMembers) && draftMembers.length > 0) {
          this.societyMemberList = draftMembers;
        } else if (!this.societyMemberList?.length) {
          this.getMemberList();
        }

      }

    }, (res) => {
      if (res.status != 200) {


      }
    })


  }
  // prefillAmendmentForm(details: any) {
  //   // Helper to convert base64 string to File object
  //   const base64ToFile = (base64Data: string, filename: string, mimeType: string) => {
  //     const byteString = atob(base64Data.split(',')[1]);
  //     const ab = new ArrayBuffer(byteString.length);
  //     const ia = new Uint8Array(ab);
  //     for (let i = 0; i < byteString.length; i++) {
  //       ia[i] = byteString.charCodeAt(i);
  //     }
  //     return new File([ab], filename, { type: mimeType });
  //   };

  //   // Form IV
  //   if (details.fileFormIV) {
  //     const file = base64ToFile(details.fileFormIV, details.sFormIVPath, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
  //     this.amendmentForm.patchValue({
  //       FileFormIV: file,
  //       FileNameFormIV: file.name
  //     });
  //   }

  //   // Comparative Chart
  //   if (details.fileComparativeChart) {
  //     const file = base64ToFile(details.fileComparativeChart, details.sComparativeChartPath, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
  //     this.amendmentForm.patchValue({
  //       FileComparativeChart: file,
  //       FileNameComparativeChart: file.name
  //     });
  //   }

  //   // Audited Accounts
  //   if (details.fileAuditedAccount) {
  //     const file = base64ToFile(details.fileAuditedAccount, details.sAuditedAccountReturnPath, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
  //     this.amendmentForm.patchValue({
  //       FileAuditedAccount: file,
  //       FileNameAuditedAccount: file.name
  //     });
  //   }

  //   // General Body Resolution
  //   if (details.fileGeneralBodyResolution) {
  //     const file = base64ToFile(details.fileGeneralBodyResolution, details.sGeneralBodyResolutionPath, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
  //     this.amendmentForm.patchValue({
  //       FileGeneralBodyResolution: file,
  //       FileNameGeneralBodyResolution: file.name
  //     });
  //   }

  //   // Executive Body Resolution
  //   if (details.fileExecutiveBodyResolution) {
  //     const file = base64ToFile(details.fileExecutiveBodyResolution, details.sExecutiveBodyResolutionPath, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
  //     this.amendmentForm.patchValue({
  //       FileExecutiveBodyResolution: file,
  //       FileNameExecutiveBodyResolution: file.name
  //     });
  //   }
  // }
  prefillFiles(details: any) {
    // Form IV
    if (details.fileFormIV) {
      const file = this.base64ToFile(details.fileFormIV, details.sFormIVPath);
      this.amendmentForm.patchValue({
        FileFormIV: file,
        FileNameFormIV: file.name
      });
    }

    // Comparative Chart
    if (details.fileComparativeChart) {
      const file = this.base64ToFile(details.fileComparativeChart, details.sComparativeChartPath);
      this.amendmentForm.patchValue({
        FileComparativeChart: file,
        FileNameComparativeChart: file.name
      });
    }

    // Audited Accounts
    if (details.fileAuditedAccount) {
      const file = this.base64ToFile(details.fileAuditedAccount, details.sAuditedAccountReturnPath);
      this.amendmentForm.patchValue({
        FileAuditedAccount: file,
        FileNameAuditedAccount: file.name
      });
    }

    // General Body Resolution
    if (details.fileGeneralBodyResolution) {
      const file = this.base64ToFile(details.fileGeneralBodyResolution, details.sGeneralBodyResolutionPath);
      this.amendmentForm.patchValue({
        FileGeneralBodyResolution: file,
        FileNameGeneralBodyResolution: file.name
      });
    }

    // Executive Body Resolution
    if (details.fileExecutiveBodyResolution) {
      const file = this.base64ToFile(details.fileExecutiveBodyResolution, details.sExecutiveBodyResolutionPath);
      this.amendmentForm.patchValue({
        FileExecutiveBodyResolution: file,
        FileNameExecutiveBodyResolution: file.name
      });
    }
    const filesMap = [
      { key: 'formIV', base64: details.fileFormIV, name: details.sFormIVPath },
      { key: 'comparativeChart', base64: details.fileComparativeChart, name: details.sComparativeChartPath },
      { key: 'auditedAccounts', base64: details.fileAuditedAccount, name: details.sAuditedAccountReturnPath },
      { key: 'resolutionGeneralBody', base64: details.fileGeneralBodyResolution, name: details.sGeneralBodyResolutionPath },
      { key: 'resolutionExecutive', base64: details.fileExecutiveBodyResolution, name: details.sExecutiveBodyResolutionPath },
    ];

    filesMap.forEach(f => {
      if (f.base64) {
        const file = this.base64ToFile(f.base64, f.name);
        this.uploadedFiles[f.key] = {
          fileName: file.name,
          content: f.base64
        };

      }
    });
  }
  // base64ToFile(base64: string, fileName: string): File {

  //   const arr = base64.split(',');
  //   const mime = arr[0].match(/:(.*?);/)![1];
  //   const bstr = atob(arr[1]);
  //   let n = bstr.length;
  //   const u8arr = new Uint8Array(n);

  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }

  //   return new File([u8arr], fileName, { type: mime });
  // }
  addAreaExtension(): void {

    if (this.areaForm.invalid) {
      this.areaForm.markAllAsTouched();
      this.toastService.showError('Please fill all required fields.');
      return;
    }

    const formValue = this.areaForm.getRawValue();

    const payload = {
      type: 4,
      existingDetails: this.societyDetails.sareaoperationname ? [this.societyDetails.sareaoperationname] : [],
      proposedChange: formValue.proposedAreaExtension ? [formValue.proposedAreaExtension] : [],
      purposesChange: formValue.purposeChange ? [formValue.purposeChange] : [],
      nocFile: null
    };

    // Find index where same type exists
    const index = this.bylawsList.findIndex(
      item => item.type === payload.type
    );

    if (index !== -1) {
      // ✅ Replace existing entry
      this.bylawsList[index] = payload;
    } else {
      // ✅ Add new entry
      this.bylawsList.push(payload);
    }

    this.toastService.showSuccess('Area saved successfully.');

    const modalElement = document.getElementById('AreaModal');
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  shouldShowAddButton(amendmentType: any): boolean {
    const name = this.getAmendmentName(amendmentType);

    return name
      ? name.trim().toLowerCase() !== 'rules and regulations of the society'
      : true;
  }
  districts: any;
  bindDistrict(iDistrictID: number): void {
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {
        if (response.status === 200) {
          this.districts = response.lstDistrict;
        } else {

          this.toastService.showError(response.message);
        }
      },
      (error) => {

        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  OpenMemberDetails(member: any) {
    this.selectedMember = member;
    console.clear();
  }

  get ByLawsDetails() {
    return this.amendmentForm.get('ByLawsDetails') as FormArray;
  }
  async deleteMember(index: number) {
    const confirmed = await this.alertService.confirmAlert(
      'Warning',
      'Are you sure you want to delete this information? This action cannot be undone.',
      'Ok',
      'Cancel'
    );
    if (confirmed) {
      // this.ngxUiLoaderService.start();
      // this.societyService.deleteMember(id).subscribe({
      //   next: (response) => {
      //     this.ngxUiLoaderService.stop();
      //     if (response.status === 200) {
      //       this.toastService.showSuccess(response.message);
      //       this.getMemberList();
      //     } else {
      //       this.toastService.showError(response.message);
      //     }
      //   },
      //   error: (error) => {
      //     this.ngxUiLoaderService.stop();
      //     this.toastService.showError(error.message);
      //   },
      // });

      // Delete by row index only — iMemId is 0 for all newly added local members
      if (index == null || index < 0 || index >= (this.societyMemberList?.length || 0)) {
        return;
      }
      this.societyMemberList = this.societyMemberList.filter(
        (_: any, i: number) => i !== index
      );

      return;
    }
  }



  onFileChange(event: any, type: any = null): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name);

      if (
        this.fileExtension !== 'jpg' &&
        this.fileExtension !== 'jpeg' &&
        this.fileExtension !== 'png' &&
        this.fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        if (type === 'uploadAadhaar') {
          this.memberForm.controls['sUploadAadharCardPath'].reset();
        }

        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 4) {
        this.toastService.showError(
          'File size should be less then or equal 4 MB'
        );


        return;
      }
      this.selectedFile = event.target.files[0];
      this.convertToBase64(file, 1);
    }
  }
  onChangeDesignation() {
    const desigId = Number(this.memberForm.controls['iMemDesId'].value);

    if (!desigId) return;

    const restricted = [14, 15, 16, 89];

    if (!restricted.includes(desigId)) return;

    const inSociety = this.societyMemberList.some(
      (member) => member.iMemDesId == desigId && member.iMemId !== this.memberForm.value.iMemId
    );

    const inBylaws = this.aplicationDetailList?.some(
      (member: any) => member.iMemDesId == desigId && member.iMemId !== this.memberForm.value.iMemId
    );

    if (inSociety || inBylaws) {
      this.toastService.showError('Designation already assigned to another member.');
      this.memberForm.controls['iMemDesId'].setValue('');
      return;
    }
  }

  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
        this.aadhaarBase64 = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  fnMemberForm() {
    this.memberForm = this.fb.group({
      index: [0],
      amendmentMemberId: [null],
      iMemId: [0],
      iMemTypeId: [0],
      sMemName: ['', [Validators.required, Validators.maxLength(50)]],
      sMemAge: [
        '',
        [
          Validators.required,
          Validators.min(18),
          Validators.max(100),
          Validators.pattern(/^\d+$/),
        ],
      ],
      iGenderid: ['0', [Validators.required, Validators.min(1)]],
      iMemCastid: ['0'],
      iMemOccupation: ['0', [Validators.required, Validators.min(1)]],
      iMaritalSta: ['0', [Validators.required, Validators.min(1)]],
      sMemHusName: [''],
      sMemShare: [''],

      sFatherName: [''],
      sAadharid: ['', Validators.required],
      midentitynumber: ['', Validators.required],
      sUploadAadharCardPath: [''],
      sAdd1: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(5),
          Validators.pattern(/^[a-zA-Z0-9\s,.\-\/#]+$/),
        ],
      ],
      sAdd2: [''],
      iMemberShipId: ['0', [Validators.required, Validators.min(1)]],
      sMemShipFee: ['', [Validators.required, Validators.maxLength(8)]],
      sMemShareCaptial: [''],
      iMemDesId: ['0', [Validators.required, Validators.min(1)]],
      iMemMobile: [
        '',
        [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)],
      ],
      iMemEmailId: [
        '',
        [
         // Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]{1,60}@[a-zA-Z.-]{1,190}\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });

    this.applySocietyBasedValidation();
  }

  applySocietyBasedValidation() {
    const disableForSociety1 = [
      'iMemTypeId',
      'iMemCastid',
      'sMemShareCaptial'
    ];

    if (this.societyId === 1) {
      disableForSociety1.forEach(controlName => {
        const ctrl = this.memberForm.get(controlName);
        ctrl?.clearValidators();
        ctrl?.setErrors(null);
        ctrl?.disable();
      });
    } else {
      disableForSociety1.forEach(controlName => {
        const ctrl = this.memberForm.get(controlName);
        ctrl?.enable();
      });

      this.memberForm.get('iMemCastid')
        ?.setValidators([Validators.required, Validators.min(1)]);
      this.memberForm.get('sMemShareCaptial')
        ?.setValidators([Validators.required, Validators.maxLength(8)]);
    }

    this.memberForm.updateValueAndValidity();
  }


  verifyAadhaar() {
    let aadhaarID = this.memberForm.get('sAadharid')?.value;

    if (!aadhaarID || aadhaarID.length !== 12) {
      this.toastService.showError('Please enter a valid 12-digit Aadhaar ID!');
      return;
    }
    if (!AadhaarValidator.validate(aadhaarID)) {
      this.toastService.showError('Invalid Aadhaar Number');
      return;
    }

    this.sendOTP(aadhaarID);
  }
  openPicker(picker: HTMLInputElement) {
    picker.showPicker?.();
    picker.focus();
  }
  objectiveList: any[] = [];
  existingObjectiveList: any[] = [];
  /** Outer trash cleared Objectives — do not auto-restore society list on Add open */
  private objectivesListCleared = false;

  /** Objectives amendment (id 2 or name contains "objective") */
  private isObjectivesAmendment(amendmentType: any): boolean {
    if (Number(amendmentType) === 2) {
      return true;
    }
    const name = (this.getAmendmentName(amendmentType) || '').toLowerCase();
    return name.includes('objective');
  }

  /** Default society objectives only — drop user-added rows in Manage Objectives */
  private resetObjectiveListKeepDefaults(): void {
    const baseline = this.existingObjectiveList || [];
    if (baseline.length) {
      this.objectiveList = JSON.parse(JSON.stringify(baseline));
    } else {
      this.objectiveList = (this.objectiveList || []).filter(
        (o: any) => !!o?.iSocietyObjid
      );
    }
    this.deletedObjective = [];
    this.objectivesListCleared = false;
    this.bylawsList = (this.bylawsList || []).filter(
      (b: any) => Number(b.type) !== 2
    );
    if (this.objectiveForm) {
      this.objectiveForm.reset({
        iSocietyDetailsId: 0,
        iSocietyObjid: 0,
        sSocietyObjDes: '',
        purposeChange: ''
      });
    }
    this.isSubmitObj = false;
  }

  /** Defaults first, then newly added objectives below them */
  private ensureDefaultObjectivesInList(): void {
    const defaults = JSON.parse(
      JSON.stringify(this.existingObjectiveList || [])
    );
    if (!defaults.length) {
      return;
    }

    if (!this.objectiveList?.length) {
      this.objectiveList = defaults;
      return;
    }

    const defaultKey = (o: any) =>
      String(o?.sSocietyObjDes || o?.objectiveName || '')
        .trim()
        .toLowerCase();

    const defaultTexts = new Set(
      defaults.map((d: any) => defaultKey(d)).filter(Boolean)
    );
    const defaultIds = new Set(
      defaults
        .map((d: any) => Number(d?.iSocietyObjid))
        .filter((id: number) => !!id)
    );

    // Newly added = not matching society default by id/text
    const addedBelow = (this.objectiveList || []).filter((o: any) => {
      const id = Number(o?.iSocietyObjid);
      if (id && defaultIds.has(id)) {
        return false;
      }
      const text = defaultKey(o);
      return !text || !defaultTexts.has(text);
    });

    this.objectiveList = [...defaults, ...addedBelow];
  }

  openSelectedAmendmentModal(selectedValue: string) {
    const selectedId = Number(selectedValue);

    switch (selectedId) {
      case 1:
        this.openModal('BylawsModal');
        break;

      case 2:
        this.ensureDefaultObjectivesInList();
        this.openModal('AddObjective');
        break;


      case 4:
        this.openModal('AreaModal');
        break;

      case 5:
        this.openModal('AddressModal');
        break;

      default:
        this.toastService.showError("Please select a valid amendment.");
        break;
    }
  }
  generateFormIV() {
    const pdf = new jsPDF("p", "pt", "a4");
    const sd = this.societyDetails || {};
    const mem = this.societyMemberList || [];
    const pageWidth = pdf.internal.pageSize.width;

    /** Date only — strip time (e.g. "07/01/2020 14:41:00" → "07/01/2020"). */
    const dateOnly = (value: any): string => {
      if (value == null || value === "") {
        return "";
      }
      const s = String(value).trim();
      if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(s)) {
        return s.split(/\s+/)[0];
      }
      const d = new Date(s);
      if (!isNaN(d.getTime())) {
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        return `${dd}/${mm}/${d.getFullYear()}`;
      }
      return s.split(/\s+/)[0] || s;
    };

    function center(text: string, y: number, bold = false) {
      pdf.setFont("helvetica", bold ? "bold" : "normal");
      pdf.text(text, pageWidth / 2, y, { align: "center" });
    }

    pdf.setFontSize(14);
    center("Form IV", 40, true);

    pdf.setFontSize(11);
    center(
      "(Application under Section 9, 10 and 13 of the Himachal Pradesh Societies Registration Act, 2006)",
      60
    );

    autoTable(pdf, {
      startY: 80,
      theme: "plain",
      styles: {
        fontSize: 11,
        cellPadding: 4,
        overflow: "linebreak"
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 100 },
        2: { cellWidth: 80 },
        3: { cellWidth: 50 },
        4: { cellWidth: 80 },
        5: { cellWidth: 125 }
      },
      body: [
        [
          { content: "Reference ID:", styles: { fontStyle: "bold" } },
          sd.sSocietyTrackingid || "",
          { content: "Amendment No:", styles: { fontStyle: "bold" } },
          "1",
          { content: "Printed On:", styles: { fontStyle: "bold" } },
          dateOnly(new Date())
        ]
      ]
    });



    const address = [
      sd.sAddress1 || "",
      sd.sAddress2 || "",
      sd.sdistrictname || "",
      sd.sPincode || ""
    ]
      .filter(x => x && x.trim() !== "")
      .join(", ");

    autoTable(pdf, {
      startY: (pdf as any).lastAutoTable.finalY + 10,
      theme: "grid",
      styles: { fontSize: 11, cellPadding: 6 },
      headStyles: { fillColor: [255, 255, 255], textColor: 0 },
      bodyStyles: { valign: "top" },

      body: [
        [
          { content: "1.", rowSpan: 2 },
          "Full Name of Society",
          { content: sd.sSocietyName || "", styles: { fontStyle: "bold" } }
        ],
        [
          "Complete Address of Society",
          { content: address || "", styles: { fontStyle: "bold" } }
        ],

        [
          { content: "2.", rowSpan: 2 },
          "Registration No.",
          {
            content: sd.sSocietyRegistrationNo || sd.sRegisrtartionNo || "",
            styles: { fontStyle: "bold" }
          }

        ],
        ["Registration Date", {
          content: dateOnly(sd.dtApprovedate || sd.dtApprovedate || ""),
          styles: { fontStyle: "bold" }
        }],

        ["3.", "Total Number of present members", {
          content: mem.length || mem.length || "",
          styles: { fontStyle: "bold" }
        }],

        ["4.", "Under which regulation the Registered Regulation of Society amendment is proposed.", ""],

        ["5.", "On which date the executive committee passed the amendment proposal.", ""],
        ["(i)", "To how many members the notice of meeting was served?", ""],
        ["(ii)", "How many members constitute the quorum?", ""],

        ["6.", "What is the date of General Meeting?", ""],
        ["(i)", "Under which rule the meeting is summoned.", ""],
        ["(ii)", "How many days earlier the previous notice was served?", ""],
        ["(iii)", "How many members remained present?", ""],
        ["(iv)", "How many members constitute the quorum of the meeting?", ""],

        [
          "7.",
          "Amendment proposed",
          {
            content:
              "Document Attached as Comparative Chart (as Annexure - I / Annexure - II)",
            styles: { fontStyle: "bold" }
          }
        ],

        [
          "8.",
          "Prescribed fee for proposed amendment in the Memorandum and Rules and Regulations",
          {
            content: "Will be submitted on demand through eChallan",
            styles: { fontStyle: "bold" }
          }
        ]
      ]
    });

    let y = (pdf as any).lastAutoTable.finalY + 40;
    pdf.setFontSize(11);

    pdf.text(
      "I ..................................................... S/o | D/o | W/o .................................................. Age ........",
      40,
      y
    );
    y += 20;

    pdf.text(
      "(Years), R/o ...........................................................................................................................................",
      40,
      y
    );
    y += 20;

    pdf.text(
      "............................................................. Designation ..................................................................... hereby",
      40,
      y
    );
    y += 20;

    const declarationText =
      "I declare that the above informations are true according to the best of my knowledge and belief, and I know giving any false information shall be punishable under sec. 49(2) of the Act.";

    const maxWidth = pageWidth - 80;
    const wrappedDeclaration = pdf.splitTextToSize(declarationText, maxWidth);

    pdf.text(wrappedDeclaration, 40, y);

    y += wrappedDeclaration.length * 14 + 10;

    const signatureLineX = pageWidth - 240;
    const signatureTextX = pageWidth - 240;

    pdf.text(".............................................................", signatureLineX, y);

    y += 10;

    pdf.text("(Signature of President)", signatureTextX, y);


    pdf.save("Form_IV.pdf");
  }

  deletedObjective: any[] = []
  async deleteObj(id: any, object: any) {
    const confirmed = await this.alertService.confirmAlert(
      'Warning',
      'Are you sure you want to delete this information? This action cannot be undone.',
      'Ok',
      'Cancel'
    );

    if (!confirmed || id === -1 || id == null) {
      return;
    }

    const obj = this.objectiveList[id];

    // Inner trash: remove from working list (new array so UI updates)
    this.objectiveList = this.objectiveList.filter(
      (_: any, i: number) => i !== id
    );

    if (obj?.iSocietyObjid) {
      this.deletedObjective.push(obj.iSocietyObjid);
    }

    const findIndex = this.bylawsList.findIndex(
      (i) => Number(i?.type) === 2
    );

    // All objectives removed — drop type-2 details so Preview hides the section
    if (!this.objectiveList?.length) {
      if (findIndex !== -1) {
        this.bylawsList = this.bylawsList.filter(
          (b: any) => Number(b.type) !== 2
        );
      }
    } else {
      const payload = {
        type: 2,
        existingDetails: this.existingObjectiveList
          .filter((o: any) => o.iSocietyObjid)
          .map((o: any, index: number) => `${index + 1}. ${o.sSocietyObjDes}`),
        proposedChange: this.objectiveList.map(
          (o: any) => `${o.sSocietyObjDes}`
        ),
        purposesChange: ['DeleteObjective'],
        nocFile: null,
        dObjectId: obj?.iSocietyObjid
          ? [obj.iSocietyObjid.toString()]
          : null
      };

      if (findIndex !== -1) {
        this.bylawsList[findIndex] = payload;
      } else {
        this.bylawsList.push(payload);
      }
    }
  }
  markFormGroupTouched(formGroup: any) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();

      if (control?.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  generateAnnexureForm() {
    const doc = new Document({
      sections: [
        {
          properties: {
            page: {
              size: {
                width: 11906,
                height: 16838,
              },
              margin: {
                top: 720,
                bottom: 720,
                left: 720,
                right: 720,
              },
            },
          },

          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              spacing: { after: 200 },
              children: [
                new TextRun({
                  text: "Annexure – I",
                  bold: true,
                  size: 34,
                }),
              ],
            }),

            new Paragraph({
              alignment: AlignmentType.CENTER,
              spacing: { after: 300 },
              children: [
                new TextRun({
                  text:
                    "Proposed Amendment in Memorandum of Association of the Society",
                  size: 26,
                }),
              ],
            }),

            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },

              rows: [
                new TableRow({
                  tableHeader: true,
                  children: [
                    this.createCellWithLineBreak(
                      ["Clause/", "Article No."],
                      true,
                      15
                    ),
                    this.createCell("Existing Provision", true, 30),
                    this.createCell("Proposed Amendment", true, 30),
                    this.createCell("Reasons", true, 25),
                  ],
                }),

                new TableRow({
                  height: {
                    value: 11000,
                    rule: HeightRule.EXACT,
                  },
                  children: [
                    this.createCell(""),
                    this.createCell(""),
                    this.createCell(""),
                    this.createCell(""),
                  ],
                }),
              ],
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "Annexure-I.docx");
    });
  }
  private createCell(
    text: string,
    isHeader = false,
    width = 25
  ): TableCell {
    return new TableCell({
      width: { size: width, type: WidthType.PERCENTAGE },

      shading: isHeader
        ? { type: ShadingType.CLEAR, fill: "D9D9D9" }
        : { type: ShadingType.CLEAR, fill: "FFFFFF" },

      borders: {
        top: { style: BorderStyle.SINGLE, size: 2 },
        bottom: { style: BorderStyle.SINGLE, size: 2 },
        left: { style: BorderStyle.SINGLE, size: 2 },
        right: { style: BorderStyle.SINGLE, size: 2 },
      },

      verticalAlign: VerticalAlign.TOP,

      children: [
        new Paragraph({
          alignment: AlignmentType.CENTER,
          children: [
            new TextRun({
              text,
              bold: isHeader,
              size: isHeader ? 24 : 22,
            }),
          ],
        }),
      ],
    });
  }
  private createCellWithLineBreak(
    lines: string[],
    isHeader = false,
    width = 25
  ): TableCell {
    return new TableCell({
      width: { size: width, type: WidthType.PERCENTAGE },

      shading: isHeader
        ? { type: ShadingType.CLEAR, fill: "D9D9D9" }
        : { type: ShadingType.CLEAR, fill: "FFFFFF" },

      borders: {
        top: { style: BorderStyle.SINGLE, size: 2 },
        bottom: { style: BorderStyle.SINGLE, size: 2 },
        left: { style: BorderStyle.SINGLE, size: 2 },
        right: { style: BorderStyle.SINGLE, size: 2 },
      },

      verticalAlign: VerticalAlign.TOP,

      children: lines.map(
        (line) =>
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text: line,
                bold: isHeader,
                size: isHeader ? 24 : 22,
              }),
            ],
          })
      ),
    });
  }
  existingAddress: any;
  proposedAddress: any;
  submitAddressChange(): void {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      this.toastService.showError('Please fill all required fields.');
      return;
    }

    const formValue = this.addressForm.getRawValue();

    const payload = {
      type: 5,
      existingDetails: formValue.existingAddress ? [formValue.existingAddress] : [],
      proposedChange: formValue.proposedAddress ? [formValue.proposedAddress, formValue.proposedDistrict] : [],
      purposesChange: formValue.purposeChange ? [formValue.purposeChange] : [],
      nocFile: null
    };


    // Find index where same type exists
    const index = this.bylawsList.findIndex(
      item => item.type === payload.type
    );

    if (index !== -1) {
      // ✅ Replace existing entry
      this.bylawsList[index] = payload;
    } else {
      // ✅ Add new entry
      this.bylawsList.push(payload);
    }
    //    this.bylawsList.push(payload);

    this.toastService.showSuccess('Address saved successfully.');

    const modalElement = document.getElementById('AddressModal');
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  isSubmitObj: boolean = false;
  fnObjectiveForm() {
    this.objectiveForm = this.fb.group({
      iSocietyDetailsId: [0],
      iSocietyObjid: [0],
      sSocietyObjDes: ['', Validators.required],
      purposeChange: ['', Validators.required]
    });
  }

  proposedChange: any;
  submitObjective(): void {
    this.isSubmitObj = true;

    if (this.objectiveForm.invalid) {
      this.markFormGroupTouched(this.objectiveForm);
      this.toastService.showError('Please fill all required fields.');
      return;
    }

    const formValue = this.objectiveForm.value;

    const objectiveName = (formValue.sSocietyObjDes || '').trim();
    const purposeChange = (formValue.purposeChange || '').trim();

    if (!objectiveName || !purposeChange) {
      this.toastService.showError('Both Objective and Purpose Change are required.');
      return;
    }

    const isDuplicate = this.objectiveList.some(
      (obj) => obj?.objectiveName?.toLowerCase() === objectiveName.toLowerCase()
    );

    if (isDuplicate) {
      this.toastService.showError('Duplicate objective detected.');
      return;
    }

    this.objectiveList.push({
      ...formValue,
      iSocietyObjid: formValue.iSocietyObjid || 0,
      objectiveName,
      purposeChange
    });
    // Keep defaults on top; newly added stay below
    this.ensureDefaultObjectivesInList();
console.log(this.objectiveList)

    const payload = {
      type: 2,
      existingDetails: this.existingObjectiveList
        .filter(obj => obj.iSocietyObjid)
        .map((obj, index) => `${index + 1}. ${obj.sSocietyObjDes}`),
      
      proposedChange:  this.objectiveList
              .map((obj, index) => ` ${obj.sSocietyObjDes}`),
      purposesChange: [purposeChange],
      nocFile: null
    };
  const findIndex = this.bylawsList.findIndex(
  (i) => i?.type === 2
);

if (findIndex !== -1) {
  this.bylawsList[findIndex] = payload;
} else {
  this.bylawsList.push(payload);
}
 console.log(this.bylawsList)


    this.objectiveForm.reset({
      iSocietyDetailsId: 0,
      iSocietyObjid: 0,
      sSocietyObjDes: '',
      purposeChange: ''
    });

    this.isSubmitObj = false;
  }
  filterAadhaar(event: any) {
    let inputValue = event.target.value;
    event.target.value = inputValue.replace(/\D/g, '').slice(0, 12);
  }
  sendOTP(aadhaarID: string) {

    setTimeout(() => {
      this.toastService.showError(`OTP sent to Aadhaar ID: ${aadhaarID}`);
    }, 1000);
  }
  filterNumbers(event: any) {
    let inputValue = event.target.value;
    event.target.value = inputValue.replace(/\D/g, '');
    if (Number(this.memberForm.get('sMemAge')?.value) > 100) {
      this.memberForm.get('sMemAge')?.setValue('100');
    }
  }
  initializeForm(): void {
    this.registrationForm = this.fb.group({
      amendments: this.fb.array([]),
      bylaws: this.fb.array([]),
      documents: this.fb.group({
        formIV: [null],
        comparativeChart: [null],
        auditedAccounts: [null],
        resolutionGeneralBody: [null],
        resolutionExecutiveBody: [null]
      })
    });
  }

  getMaritalStatusChange(event: any) {
    const maritalStatus = event.target.value;
    const gender = this.memberForm.get('iGenderid')?.value;

    this.showHusbandWife = false;
    this.showFather = false;

    this.memberForm.get('sMemHusName')?.clearValidators();
    this.memberForm.get('sFatherName')?.clearValidators();

    if (maritalStatus == '1') {
      this.showFather = true;
      this.memberForm.get('sFatherName')?.setValidators([Validators.required]);
    }

    if (maritalStatus == '2') {
      if (gender == '2') {
        this.showHusbandWife = true;
        this.memberForm.get('sMemHusName')?.setValidators([Validators.required]);
      }

      if (gender == '1' && this.societyId == 1) {
        this.showFather = true;
        this.memberForm.get('sFatherName')?.setValidators([Validators.required]);
      }

      if (gender == '1' && this.societyId != 1) {
        this.showHusbandWife = true;
        this.memberForm.get('sMemHusName')?.setValidators([Validators.required]);
      }
    }

    this.memberForm.get('sMemHusName')?.updateValueAndValidity();
    this.memberForm.get('sFatherName')?.updateValueAndValidity();
  }
  getMemberType() {
    const dataval = this.societyDetails.iSCategoryid;

    this.societyService.getMemberType(dataval).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.memberTypeList = response.data;
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  getCastCategory() {
    this.societyService.getMemberCastCategory().subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.castCategoryList = response.data;
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  getOccuption() {
    this.societyService.getMemberOccuption().subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.occuptionList = response.data;

        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  getMembershipType() {
    this.societyService.getMembershipType().subscribe({
      next: (response) => {
        if (response.status === 200) {
          const allTypes = response.data;
          const allowed = ['founder', 'annual member'];


          if (this.societyId === 1) {
            this.membershipTypeList = allTypes.filter((type: any) =>
              allowed.includes(type.name.toLowerCase())
            );
          }
          else if (this.societyId === 2) {
            this.membershipTypeList = allTypes.filter(
              (type: any) =>
                type.name.toLowerCase() === 'primary' ||
                type.name.toLowerCase() === 'secondary'
            );
          }
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }


   getDesignation() {
    this.societyService.getMemberDesignation().subscribe({
      next: (response) => {
        if (response.status === 200) {
          let data = response.data;

          if (this.societyId !== 1) {
            data = data.filter(
              (item: any) =>
                item.id !== 16 && item.id !== 17 && item.id !== 125
            );
          }
          if (this.societyId === 1) {
            data = data.filter(
              (item: any) =>
                item.id !== 17
            );
          }
          this.designationList = data;
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  members: any[] = [];  // store all members
  editIndex: number = -1;

  openEditMemberModal(member: any, index: number): void {
    this.editIndex = index;
    this.memberForm.patchValue(member);

    this.showHusbandWife = member.iMaritalSta === 2;
    this.showFather = member.iMemTypeId != 2;

    const modalElement: any = document.getElementById('AddMemberModal');
    const modal = new Modal(modalElement);
    modal.show();
  }
  openAddMemberModal() {
    this.resetMemberForm();
    const modalEl: any = document.getElementById('AddMemberModal');
    const modal = new Modal(modalEl);
    modal.show();
  }
  selectedIdentityType: any;
  editMember(member: any, index: any) {

    this.selectedIdentityType = member.sAadharid;

    this.memberForm.patchValue({
      index: index,
      amendmentMemberId: member.amendmentMemberId ? member.amendmentMemberId : 0,
      iMemId: member.iMemId,
      iMemTypeId: Number(member.iMemTypeId),
      sMemName: member.sMemName,
      sMemAge: member.sMemAge,
      iGenderid: Number(member.iGenderid),
      iMemCastid: Number(member.iMemCastid),
      iMemOccupation: Number(member.iMemOccupation),
      iMaritalSta: Number(member.iMaritalSta),
      sMemHusName: member.sMemHusName,
      sFatherName: member.sFatherName,
      sAadharid: member.sAadharid,
      midentitynumber: member.midentitynumber,
      sAdd1: member.sAdd1,
      sAdd2: member.sAdd2,
      iMemberShipId: Number(member.iMemberShipId),
      sMemShipFee: member.sMemShipFee,
      sMemShareCaptial: member.sMemShareCaptial,
      sMemShare: Number(member.sMemShare),
      iMemDesId: Number(member.iMemDesId),
      iMemMobile: member.iMemMobile,
      iMemEmailId: member.iMemEmailId,
      sUploadAadharCardPath: member.sUploadAadharCardPath
    });

    this.getMaritalStatusChange({
      target: { value: member.iMaritalSta }
    });
    if (member.sUploadAadharCardPath) {
      let file = this.base64ToFile(member.sUploadAadharCardPath, member.fileName);

      this.base64String = member.sUploadAadharCardPath;
      this.fileName = member.fileName;
      setTimeout(() => {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);

        const fileInput = document.getElementById('formFile') as HTMLInputElement;
        fileInput.files = dataTransfer.files;
      }, 1000)
      this.memberForm.patchValue({
        sUploadAadharCardPath: member.fileName
      });

    } else {
      this.base64String = '';
      this.fileName = '';
    }


    // sUploadAadharCardPath
  }



  // submitMember() {
  //   this.isSubmitMember = true;

  //   if (this.memberForm.invalid) {
  //     this.memberForm.markAllAsTouched();
  //     this.toastService.showError('Please fill all required fields.');
  //     return;
  //   }
  //   this.societyMember = this.memberForm.value;
  //   const aadhaarExists = this.societyMemberList.some(
  //     (member: any) =>
  //       member.midentitynumber === this.societyMember.midentitynumber &&
  //       member.iMemId !== this.societyMember.iMemId
  //   );

  //   if (aadhaarExists) {
  //     this.toastService.showError('Identity number already exists!');
  //     return;
  //   }

  //   if (!/[a-zA-Z]/.test(this.memberForm.get('sAdd1')?.value)) {
  //     this.toastService.showError('Please enter valid Address1');
  //     return;
  //   }
  //   if (
  //     !/[a-zA-Z]/.test(this.memberForm.get('sAdd2')?.value) &&
  //     this.memberForm.get('sAdd2')?.value
  //   ) {
  //     this.toastService.showError('Please enter valid Address2');
  //     return;
  //   }
  //   if (this.memberForm.get('sMemShipFee')?.value <= 0) {
  //     this.toastService.showError('Please enter valid Fee Amount');
  //     return;
  //   }
  //   const emailControl = this.memberForm.get('iMemEmailId');
  //   if (emailControl?.value && emailControl.invalid) {
  //     this.toastService.showError('Please enter a valid email address.');
  //     return;
  //   }
  //   this.societyMember.file = this.base64String;
  //   this.isLoading = true;
  //   this.societyMember.fileName = this.fileName;

  //   // this.ngxUiLoaderService.start();
  //   // this.societyService.addSocietyMember(this.societyMember).subscribe({
  //   //   next: (response) => {
  //   //     this.ngxUiLoaderService.stop();
  //   //     this.isLoading = false;
  //   //     this.isSubmitMember = false;
  //   //     if (response.status === 200) {
  //   //       this.toastService.showSuccess(response.message);
  //   //       this.maritalStatus = false;
  //   //       this.fnMemberForm();
  //   //       this.getMemberList();
  //   //       this.getAllData('All');
  //   //     } else {
  //   //       this.toastService.showError(response.message);
  //   //     }
  //   //   },
  //   //   error: (error) => {
  //   //     this.ngxUiLoaderService.stop();
  //   //     this.isLoading = false;
  //   //     this.isSubmitMember = false;
  //   //     this.toastService.showError(error.message);
  //   //   },
  //   // });
  // }

  submitMember() {
    this.isSubmitMember = true;

    if (this.memberForm.invalid) {
      this.memberForm.markAllAsTouched();
      this.toastService.showError('Please fill all required fields.');
      return;
    }

    let formData = { ...this.memberForm.value };

    formData.iGenderid = Number(formData.iGenderid);
    formData.iMemOccupation = Number(formData.iMemOccupation);
    formData.iMaritalSta = Number(formData.iMaritalSta);
    formData.iMemberShipId = Number(formData.iMemberShipId);
    formData.iMemDesId = Number(formData.iMemDesId);
    formData.sMemShipFee = Number(formData.sMemShipFee);
    formData.sMemAge = Number(formData.sMemAge);
    formData.sMemShare = formData.sMemShare.toString()

    const exists = this.societyMemberList.some(
      (m: any) =>
        m.midentitynumber === formData.midentitynumber &&
        m.iMemId !== formData.iMemId
    );

    if (exists) {
      this.toastService.showError('Identity number already exists!');
      return;
    }

    if (!/[a-zA-Z]/.test(formData.sAdd1)) {
      this.toastService.showError('Please enter valid Address1');
      return;
    }

    if (formData.sAdd2 && !/[a-zA-Z]/.test(formData.sAdd2)) {
      this.toastService.showError('Please enter valid Address2');
      return;
    }

    if (formData.sMemShipFee <= 0) {
      this.toastService.showError('Please enter valid Fee Amount');
      return;
    }

    const emailControl = this.memberForm.get('iMemEmailId');
    if (emailControl?.value && emailControl.invalid) {
      this.toastService.showError('Please enter a valid email address.');
      return;
    }

    formData.file = this.base64String;
    formData.fileName = this.fileName;
    if (formData.file == '' && formData.fileName == '') {
      this.toastService.showError('Please Upload valid Identity File.');
      return;
    }

    formData.sGender = this.getGenderName(formData.iGenderid);
    formData.sMaritalStatus = this.getMaritalName(formData.iMaritalSta);

    formData.sOccupation =
      this.occuptionList.find(x => x.id == formData.iMemOccupation)?.name || '';

    formData.sMembershiptypename =
      this.membershipTypeList.find(x => x.id == formData.iMemberShipId)?.name || '';

    formData.sMemberDesignation =
      this.designationList.find(x => x.id == formData.iMemDesId)?.name || '';

    if (formData.iMemId && formData.iMemId !== 0) {
      const index = this.societyMemberList.findIndex(
        (x) => x.iMemId === formData.iMemId
      );

      if (index !== -1) {
        this.societyMemberList[index] = formData;
      }
    } else if (this.byLawsId && formData.index) {

      let index = formData.index;
      delete formData.index;
      this.societyMemberList[index] = formData;
    }
    else {
      delete formData.index;
      formData.iMemId = 0;
      this.societyMemberList.push(formData);
    }

    this.toastService.showSuccess('Member saved Successfully!');
    // this.hideModal('GeneralBodyMembers');
    // document.body.classList.remove('modal-open');
    // 🔄 Reset form + file
    this.resetMemberForm();
    this.base64String = '';
    this.fileName = '';
    this.aadhaarBase64 = '';
    this.isSubmitMember = false;
  }
 get filteredMembers() {
  // Governing Body only — General Member (88) stays in General Body list
  const allowedIds = [14, 15, 16, 89, 125];

  const orderMap: any = {
    14: 1,  // President
    15: 2,  // Vice President
    16: 3,  // Secretary
    89: 4,  // Treasurer
    125: 5, // Executive Member
  };

  return (this.societyMemberList || [])
    .filter(item =>
      allowedIds.includes(Number(item.iMemDesId))
    )
    .sort((a, b) =>
      orderMap[a.iMemDesId] - orderMap[b.iMemDesId]
    );
}
  getGenderName(id: number): string {
    switch (id) {
      case 1: return 'Male';
      case 2: return 'Female';
      case 3: return 'Other';
      default: return '';
    }
  }

  getMaritalName(id: number): string {
    switch (id) {
      case 1: return 'Unmarried';
      case 2: return 'Married';
      default: return '';
    }
  }
  getMemberList() {
    this.ngxUiLoaderService.start();
    this.societyService.getSocietyMemberList().subscribe({
      next: (response) => {
        this.ngxUiLoaderService.stop();
        if (response.status === 200) {
          this.societyMemberList = response.data;

        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.toastService.showError(error.message);
      },
    });
  }
  allowOnlyNumbers(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    // Handle typing
    if (event.type === 'keypress') {
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }

    // Handle paste
    if (event.type === 'paste') {
      const pastedInput: string = (event.clipboardData).getData('text');
      if (!/^\d+$/.test(pastedInput)) {
        event.preventDefault();
      }
    }
  }

  allowOnlyCharacters(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (this.spacecount === 1 && charCode === 32) {
      event.preventDefault();
      return false;
    }
    // Allow A-Z and a-z only
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 32
    ) {
      this.spacecount = 0;
      if (charCode === 32) {
        this.spacecount = 1;
      }

      return true;
    }

    event.preventDefault();
    return false;
  }
  notAllowSpecialChar(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow A-Z, a-z, 0-9, and space only
    if (charCode === 32) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  onlyAllowonespace(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow A-Z, a-z, 0-9, and space only
    if (charCode === 32 && this.firstnext === false) {
      this.firstnext = true;
      return true;
    } else if (charCode === 32 && this.firstnext === true) {
      event.preventDefault();
      return false;
    } else {
      this.firstnext = false;
      return true;
    }
  }
  allowOnlyCharacters_Number(event: KeyboardEvent) {
    const charCode = event.charCode;

    // Allow A-Z and a-z only
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      (charCode >= 48 && charCode <= 57)
    ) {
      return true;
    }

    event.preventDefault();
    return false;
  }
  openAddMemberModel() {
    this.maritalStatus = false;
    this.getMemberType();
  }
  areaOperationList: any;
  getAllData(action: any): void {
    this.ngxUiLoaderService.start();

    this.societyService.getSocietyTabsData('All', 0).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();

        if (response?.status === 200 && action === 'All') {
          const data = response?.data;

          this.societyDetails = data?.showSocietyDetails || {};

          if (data?.societyAreaOperation?.length > 0) {
            this.areaOperationList = data.societyAreaOperation;
          }

          // Patch form (uncomment if needed)
          /*
          this.societyDetailForm.patchValue({
            userName: this.societyDetails?.userName,
            address: this.societyDetails?.address
          });
          */

          if (this.societyDetails?.ssocietytypename ) {
        

            this.existingObjectiveList = data?.societyObjects || [];
            this.firstnext = this.objectiveList.length > 0;

            const societyMembers = data?.societyMember || [];

            if (!this.byLawsId) {
              this.societyMemberList = societyMembers;
              if (!this.objectivesListCleared) {
                this.objectiveList = JSON.parse(
                  JSON.stringify(data?.societyObjects || [])
                );
              }
            } else {
              if (!this.societyMemberList?.length && societyMembers.length) {
                this.societyMemberList = societyMembers;
              }
              // After refresh: Manage Objectives = society defaults only
              this.objectiveList = JSON.parse(
                JSON.stringify(data?.societyObjects || [])
              );
              this.objectivesListCleared = false;
            }

          }
        }
      },

      error: (error: any) => {
        this.ngxUiLoaderService.stop();
        this.toastService.showError(error?.message || 'Something went wrong');
      }
    });
  }
  base64ToFile(base64: string, fileName: string): File {

    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }

  isNocGenerated: boolean = false;
  certificateNoc: boolean = false;
  generateNoc() {
    this.isNocGenerated = true;
    this.certificateNoc = true;
    this.downloadCertificateses()
  }
  downloadCertificateses() {
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const marginX = 50;
    const lineHeight = 16;
    let y = 50;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(12);
    pdf.text('DECLARATION / NOC', pageWidth / 2, y, { align: 'center' });

    y += 22;
    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'normal');
    pdf.text('(To be given by the Owner of the Premises)', pageWidth / 2, y, { align: 'center' });

    y += 40;
    pdf.setFontSize(12);

    const intro = `I, ___________________ S/o / D/o / W/o ___________________, do hereby solemnly affirm and declare as under:`;
    const introLines = pdf.splitTextToSize(intro, pageWidth - marginX * 2);
    pdf.text(introLines, marginX, y);
    y += introLines.length * lineHeight + 15;

    const writeParagraph = (segments: { text: string; bold?: boolean }[]) => {
      let x = marginX;

      segments.forEach(seg => {
        pdf.setFont('helvetica', seg.bold ? 'bold' : 'normal');

        const words = seg.text.split(' ');
        words.forEach(word => {
          const testWidth = pdf.getTextWidth(word + ' ');
          if (x + testWidth > pageWidth - marginX) {
            y += lineHeight;
            x = marginX;
          }
          pdf.text(word + ' ', x, y);
          x += testWidth;
        });
      });

      y += lineHeight + 4;
    };


    const address = (
      ` ${this.societyDetails?.sAddress1 ?? ''} ` + `${this.societyDetails?.sAddress2 ?? ''}, ` +
      `DISTRICT ${this.societyDetails?.sdistrictname ?? ''} ` +
      `- ${this.societyDetails?.sPincode ?? ''} (HP)`
    ).toUpperCase();


    const societyName = (this.societyDetails?.sSocietyName ?? '').toUpperCase();
    const userName = (this.societyDetails?.userName ?? '').toUpperCase();


    writeParagraph([
      { text: '1. That I am the legal owner and in possession of the premises situated at C/O Sh. ' },
      { text: userName + '.', bold: true }
    ]);

    writeParagraph([
      { text: '2. That I have ' },
      { text: 'No Objection', bold: true },
      { text: ' if the registered office of the proposed ' },
      { text: societyName, bold: true },
      { text: ' is established at my above-said premises and the same may be used by the society to carry out its activities.' }
    ]);

    writeParagraph([
      {
        text: '3. That I further declare that the contents of my above declaration are true and correct to the best of my Knowledge and if the contents of above declaration are found incorrect / wrong or misleading, the authorities shall have the right to take appropriate action against me as per Provisions of law.'
      }
    ]);


    y += 40;
    pdf.setFont('helvetica', 'normal');
    pdf.text('(Signature)', marginX, y);

    y += 50;
    pdf.setFont('helvetica', 'normal');
    pdf.text('In the presence of following witness :', marginX, y);

    y += 25;

    pdf.setFont('helvetica', 'bold');
    pdf.text('Witness Details', marginX, y);

    y += 20;

    pdf.setFont('helvetica', 'normal');
    pdf.text('Name :', marginX, y);

    pdf.line(marginX + 60, y + 3, pageWidth - marginX, y + 3);

    y += 22;

    pdf.text('Address :', marginX, y);

    pdf.line(marginX + 60, y + 3, pageWidth - marginX, y + 3);

    y += 35;

    y += 40;
    pdf.setFont('helvetica', 'normal');
    pdf.text('(Signature)', marginX, y);


    pdf.save('NOC_Declaration.pdf');
  }

 
    async  downloadFile(fileName: any) {
    // const fileUrl = this.configService.getFileUrl() + fileName;
    // const link = document.createElement('a');
    // link.href = fileUrl;
    // link.download = fileName;
    // link.target = '_blank'; 
    // link.click();
  this.base64Pdf=''
  let fileUrl: any;
    // New file selected in UI
  if (fileName) {

   


  if (fileName?.sUploadAadharCardPath && fileName?.sUploadAadharCardPath.startsWith('data:')) {
    // Already Base64 data URL
  
    fileUrl =    fileName.sUploadAadharCardPath;
  

    const blob = this.base64ToBlob(fileUrl, "application/pdf");

    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

    this.openModal('viewDocumentDetails')
 
  } else {
    // Existing server file
    if(!fileName?.fileName){
this.toastService.showInfo('Document not Available');
return
    }
   
     fileUrl = this.configService.getFileUrl() + fileName?.fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName?.fileName;
    link.target = '_blank'; 
    link.click();

  }

 
  // previewWindow.document.close();
  }

  // Existing file on server → preview server file
  // if (fileName) {
  //   const fileUrl = this.configService.getFileUrl() + fileName;

  //   window.open(fileUrl, '_blank');
  //   return;
  // }




  }

  resetMemberForm() {
    this.isSubmitMember = false;
    this.memberForm.reset();
    this.fnMemberForm();
  }
  operationofArea2006: any[] = [];
  getDropdownData() {
    this.societyService.getDropDownData().subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.operationofArea2006 = response.data.operationofArea2006;
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  getAmendmentType(): void {
    this.byLawsService.Amendsmenttypes().subscribe({
      next: (response: any) => {
        if (response.status === 200) {

          if (this.societyDetails?.iAreaOperation === 111) {
            this.AmendmentType = response.data.filter(
              (x: any) =>
                x.name !== "Extension of the Area of Operation" &&
                x.type !== 2
            );
          } else {

            this.AmendmentType = response.data.filter(
              (item: any) => item.type === 1
            );

          }

        }
      },
      error: (err) => {
        console.error('Failed to fetch amendment types', err);
      }
    });
  }



  getAmendmentName(id: any): string {
    const amendment = this.AmendmentType.find(a => a.id == id);
    return amendment ? amendment.name : '';
  }

  get Amendments(): FormArray {
    return this.amendmentForm.get('Amendments') as FormArray;
  }
  showMembersSection = false;

  openMembersSection() {
    this.showMembersSection = true;
  }
  Uploadedkeys: any[] = []
  openPreviewModal() {

    this.formData = {
      ...this.registrationForm.value,
      amendmentNo: this.amendmentsList.length,
      referenceId: this.registrationForm.value.referenceId,
      personName: this.registrationForm.value.personName,
      address: this.registrationForm.value.address,
      mobile: this.registrationForm.value.mobile,
      email: this.registrationForm.value.email,
      existingObjectives: this.registrationForm.value.existingObjectives || [],
      proposedObjectives: this.registrationForm.value.proposedObjectives || []
    };
    this.Uploadedkeys = Object.keys(this.uploadedFiles).filter(
      (key) => !!this.uploadedFiles[key]?.content
    );
    const modalElement = document.getElementById('previewModal') as HTMLElement;

    if (!modalElement) {
      console.error("Preview modal element not found in DOM");
      return;
    }

    const modal = new Modal(modalElement);

    modal.show();
  }

  // addAmendment(item: any): void {

  //   this.amendmentsList.push(item);

  //   localStorage.setItem("amendmentsList", JSON.stringify(this.amendmentsList));
  // }
  addAmendment(
    item: any,
    amendmentTypeRef: any,
    resolutionNoRef: any,
    resolutionDateRef: any
  ): void {


    let type = this.amendmentsList.find(i => i?.amendmentType == item.amendmentType)
    if (type) {
      this.toastService.showError('This Amendment Already Added!.');
      return;
    }

    if (
      !item.amendmentType ||
      !item.resolutionNo?.trim() ||
      !item.resolutionDate
    ) {
      this.toastService.showError('Please fill all required fields.');
      return;
    }

    const newEntry = {
      amendmentType: item.amendmentType,
      resolutionNo: item.resolutionNo.trim(),
      resolutionDate: item.resolutionDate,
      addedOn: new Date()
    };

    this.amendmentsList.push(newEntry);
    this.clearRemovedAmendmentType(Number(item.amendmentType));
    this.cacheAmendmentsList();
    this.persistAmendmentsDraft();

    amendmentTypeRef.value = '';
    resolutionNoRef.value = '';
    resolutionDateRef.value = '';
  }
  bylawsList: {
    type?: string | Number;
    //existingDetails: string;
    // proposedChange: string;
    // purposesChange: string;
    existingDetails: string[];

    proposedChange: string[];
    purposesChange: string[];
    nocFile?: File | null;
  }[] = [];

  addBylaw(data: {
    existingDetails: string;
    proposedChange: string;
    purposesChange: string,

  }) {
    if (!data.purposesChange || data.purposesChange.trim() === "") {
      this.toastService.showError("Please enter purpose change.");
      return;
    }

    const newEntry = {
      type: 1,
      id: this.bylawsList.length + 1,
      existingDetails: [data.existingDetails],
      proposedChange: [data.proposedChange],
      purposesChange: [data.purposesChange],
      addedOn: new Date()
    };

    //  this.bylawsList.push(newEntry);

    // Find index where same type exists
    const index = this.bylawsList.findIndex(
      item => item.type === newEntry.type
    );

    if (index !== -1) {
      // ✅ Replace existing entry
      this.bylawsList[index] = newEntry;
    } else {
      // ✅ Add new entry
      this.bylawsList.push(newEntry);
    }
    this.toastService.showSuccess('Name saved successfully.');

  }
  getMaritalStatus(event: any) {

    const genderId = event.target.value;

    this.memberForm.patchValue({
      iMaritalSta: '0'
    });

    this.memberForm.get('iMaritalSta')?.markAsUntouched();
    this.memberForm.get('iMaritalSta')?.markAsPristine();

  }
  mapByLawsPayload(
    source: any,
    options?: { isCompleted?: boolean | number }
  ) {
    return {
      iByLawId: this.byLawsId ? this.byLawsId : 0,
      iSocietyDetailsId: this.societyDetails.iSocietyDetailsId || 0,
      iSocietyUserID: this.societyDetails.iSocietyUserId || 0,
      iUserId: 0,
      isCompleted: options?.isCompleted ?? true,

      fileNameFormIV: source.UploadedFiles?.formIV?.fileName || null,
      fileFormIV: source.UploadedFiles?.formIV?.content || null,

      fileNameComparativeChart: source.UploadedFiles?.comparativeChart?.fileName || null,
      fileComparativeChart: source.UploadedFiles?.comparativeChart?.content || null,

      fileNameAuditedAccount: source.UploadedFiles?.auditedAccounts?.fileName || null,
      fileAuditedAccount: source.UploadedFiles?.auditedAccounts?.content || null,

      fileNameGeneralBodyResolution: source.UploadedFiles?.resolutionGeneralBody?.fileName || null,
      fileGeneralBodyResolution: source.UploadedFiles?.resolutionGeneralBody?.content || null,

      fileNameExecutiveBodyResolution: source.UploadedFiles?.resolutionExecutive?.fileName || null,
      fileExecutiveBodyResolution: source.UploadedFiles?.resolutionExecutive?.content || null,

      amendments: (source.amendments || []).map((a: any) => ({
        amendmentType: Number(a.amendmentType),
        resolutionNo: a.resolutionNo,
        resolutionDate: new Date(a.resolutionDate).toISOString()
      })),

      byLawsDetails: (source.bylaws || []).map((b: any) => ({
        sAmmendmentType: Number(b.type),
        sExistByLawsDetail: b.existingDetails,
        sNewByLawsDetail: b.proposedChange,
        reason: b.purposesChange || null,
        nocUpload: b.NOCUpload || null,
        fileNOCUpload: b.fileNOCUpload || null,
        dObjectId: b.dObjectId || null
      })),
      memberList: this.societyMemberList

    };
  }




  convertFileToBase64(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result as string);
      };

      reader.onerror = error => reject(error);

      reader.readAsDataURL(file);
    });
  }


  async submitAllData() {
    debugger;
    const amendments: any = this.amendmentsList ? this.amendmentsList : JSON.parse(localStorage.getItem("amendmentsList") || "[]");
    const bylaws: any = this.bylawsList || "[]";
    const files = this.uploadedFiles || "{}";
    const minMembers = 7;
    if (amendments.length === 0 && bylaws.length === 0) {
      this.toastService.showError("No data to submit!");
      return;
    }
    if (this.societyMemberList.length < minMembers) {
      this.toastService.showError(`Please add at least ${minMembers} members to continue.`);
      return;
    }
    for (const bylaw of bylaws) {

      if (!bylaw.nocFile) continue;

      const base64NOC = await this.convertFileToBase64(bylaw.nocFile);

      bylaw['NOCUpload'] = base64NOC;
      bylaw['fileNOCUpload'] = bylaw?.nocFile?.name ? bylaw?.nocFile.name : 'fileNOCUpload';
    }


    const payload = {
      amendments: amendments,
      bylaws: bylaws,
      UploadedFiles: files,
      deletedObjective: this.deletedObjective
    };





    // Rule 2: Each amendmentType must have corresponding bylaws
    const missingTypes = amendments
      .map((a: any) => Number(a.amendmentType))
      .filter((type: number) =>
        !bylaws.some((b: any) => Number(b.type) == type)
      );

    if (missingTypes.length > 0) {

      if (missingTypes.length == 1 && missingTypes[0] == 2 && this.deletedObjective.length > 0) {

      } else if (missingTypes.length == 1 && missingTypes[0] == 3) {

      } else {
        this.toastService.showError(`Missing bylaws details for AmendmentType,Please Add Details For Each`);
        return;
      }


    }

    const transformedPayload = this.mapByLawsPayload(payload);


    this.byLawsService.applyAmendsments2006(transformedPayload).subscribe({
      next: (res: any) => {
        if (res?.status === 200) {
          this.toastService.showSuccess(res.message);

          localStorage.removeItem("amendmentsList");
          localStorage.removeItem("bylawsList");
          localStorage.removeItem("uploadedFiles");

          this.amendmentsList = [];
          this.bylawsList = [];
          localStorage.removeItem("bylawsList");
          this.uploadedFiles = {};

          this.hideModal('previewModal');


          this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/bylaws']);
          });
        } else {
          this.toastService.showError(res?.message || "Something went wrong");
        }
      },

      error: (err) => {
        console.error(err);
        this.toastService.showError("API submission failed!");
      }
    });

  }

  onIdentityTypeChange(type: string) {
    this.selectedIdentityType = type;

    const identityCtrl = this.memberForm.get('midentitynumber');
    identityCtrl?.reset();
    identityCtrl?.clearValidators();

    if (type === 'aadhaarCard') {
      identityCtrl?.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]{12}$/)
      ]);
    }
    else if (type === 'voterId') {
      identityCtrl?.setValidators([
        Validators.required,
        Validators.pattern(/^[A-Z]{3}[0-9]{7}$/)
      ]);
    }
    else if (type === 'drivingLicense') {
      identityCtrl?.setValidators([
        Validators.required,
        Validators.pattern(/^[A-Z0-9]{15}$/)
      ]);
    }
    else if (type === 'panCard') {
      identityCtrl?.setValidators([
        Validators.required,
        Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
      ]);
    }
    else if (type === 'passport') {
      identityCtrl?.setValidators([
        Validators.required,
        Validators.pattern(/^[A-Z][0-9]{7}$/)
      ]);
    }

    identityCtrl?.updateValueAndValidity();
  }



  async removeAmendment(index: number): Promise<void> {
    const removed = this.amendmentsList[index];
    if (!removed) {
      return;
    }

    const type = Number(removed.amendmentType);
    const isObjectives =
      this.isObjectivesAmendment(type) ||
      this.isObjectivesAmendment(removed.amendmentType);

    if (isObjectives) {
      const confirmed = await this.alertService.confirmAlert(
        'Warning',
        'Newly added objectives will be permanently deleted. Do you want to continue?',
        'Ok',
        'Cancel'
      );
      if (!confirmed) {
        return;
      }
    }

    // Remove Add-modal details for this amendment type
    this.bylawsList = (this.bylawsList || []).filter(
      (b: any) => Number(b.type) !== type
    );

    // Outer trash on Objectives → remove newly added objectives; keep society defaults
    if (isObjectives) {
      this.resetObjectiveListKeepDefaults();
      this.markAmendmentTypeRemoved(type);
    }

    if (this.Amendments?.length > index) {
      this.Amendments.removeAt(index);
    }
    this.amendmentsList.splice(index, 1);

    this.cacheAmendmentsList();
    this.persistAmendmentsDraft();
  }

  private getRemovedTypesCacheKey(): string {
    return this.byLawsId
      ? `bylaws2006_removed_types_${this.byLawsId}`
      : 'bylaws2006_removed_types_draft';
  }

  private getRemovedAmendmentTypes(): Set<number> {
    try {
      const raw = localStorage.getItem(this.getRemovedTypesCacheKey());
      if (!raw) {
        return new Set();
      }
      const arr = JSON.parse(raw);
      return new Set(
        (Array.isArray(arr) ? arr : [])
          .map((n: any) => Number(n))
          .filter((n: number) => !Number.isNaN(n))
      );
    } catch {
      return new Set();
    }
  }

  private markAmendmentTypeRemoved(type: number): void {
    const set = this.getRemovedAmendmentTypes();
    set.add(Number(type));
    localStorage.setItem(
      this.getRemovedTypesCacheKey(),
      JSON.stringify([...set])
    );
  }

  private clearRemovedAmendmentType(type: number): void {
    const set = this.getRemovedAmendmentTypes();
    if (!set.has(Number(type))) {
      return;
    }
    set.delete(Number(type));
    localStorage.setItem(
      this.getRemovedTypesCacheKey(),
      JSON.stringify([...set])
    );
  }

  private getAmendmentsCacheKey(): string {
    return this.byLawsId
      ? `bylaws2006_amendments_${this.byLawsId}`
      : 'bylaws2006_amendments_draft';
  }

  private cacheAmendmentsList(): void {
    const json = JSON.stringify(this.amendmentsList || []);
    localStorage.setItem(this.getAmendmentsCacheKey(), json);
    localStorage.setItem('amendmentsList', json);
  }

  private restoreAmendmentsFromCache(): void {
    try {
      const raw = localStorage.getItem(this.getAmendmentsCacheKey());
      if (!raw) {
        return;
      }
      const parsed = JSON.parse(raw);
      const removedTypes = this.getRemovedAmendmentTypes();
      if (Array.isArray(parsed) && parsed.length) {
        this.amendmentsList = parsed.filter(
          (a: any) => !removedTypes.has(Number(a?.amendmentType))
        );
      }
    } catch {
      /* ignore corrupt cache */
    }
  }

  /** Merge cached rows missing from API (e.g. before draft sync completed) */
  private mergeCachedAmendments(): void {
    try {
      const raw = localStorage.getItem(this.getAmendmentsCacheKey());
      if (!raw) {
        return;
      }
      const removedTypes = this.getRemovedAmendmentTypes();
      const cached: any[] = JSON.parse(raw);
      cached.forEach((c) => {
        const type = Number(c?.amendmentType);
        if (
          Number.isNaN(type) ||
          removedTypes.has(type) ||
          this.amendmentsList.some((a) => Number(a.amendmentType) === type)
        ) {
          return;
        }
        this.amendmentsList.push({
          amendmentType: c.amendmentType,
          resolutionNo: (c.resolutionNo || '').trim(),
          resolutionDate: c.resolutionDate,
          addedOn: c.addedOn ? new Date(c.addedOn) : new Date()
        });
      });
    } catch {
      /* ignore */
    }
  }

  /** Save amendment rows to DB so refresh keeps the list (draft, not final submit).
   *  Keep IsCompleted as 7 so Action pencil stays available on Amendments list. */
  private persistAmendmentsDraft(): void {
    if (!this.societyDetails?.iSocietyDetailsId) {
      return;
    }
    // Empty list allowed when editing existing draft (deleted last amendment must sync)
    if (!this.amendmentsList?.length && !this.byLawsId) {
      this.cacheAmendmentsList();
      return;
    }

    const payload = this.mapByLawsPayload(
      {
        amendments: this.amendmentsList || [],
        bylaws: this.bylawsList,
        UploadedFiles: this.uploadedFiles
      },
      { isCompleted: 7 as any }
    );

    this.byLawsService.applyAmendsments2006(payload).subscribe({
      next: (res: any) => {
        if (res?.status !== 200) {
          return;
        }
        const newId =
          res?.data?.iByLawsId ??
          res?.data?.iByLawId ??
          res?.data?.iByLawsID;
        if (!this.byLawsId && newId) {
          const draftKey = this.getAmendmentsCacheKey();
          this.byLawsId = newId;
          localStorage.setItem(
            `bylaws2006_amendments_${newId}`,
            localStorage.getItem(draftKey) || JSON.stringify(this.amendmentsList)
          );
          localStorage.removeItem(draftKey);
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { byLawsId: newId },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      },
      error: () => {
        /* list remains in localStorage cache */
      }
    });
  }

  /** True when amendment type is still in the registration list */
  isAmendmentTypeActive(type: any): boolean {
    return (this.amendmentsList || []).some(
      (a: any) => Number(a?.amendmentType) === Number(type)
    );
  }

  /** TASK: hide Proposed section when empty — undo if manager asks to revert */
  hasProposedContent(proposed: any): boolean {
    if (proposed == null || proposed === '') {
      return false;
    }
    if (Array.isArray(proposed)) {
      return proposed.some((p: any) => !!String(p ?? '').trim());
    }
    return !!String(proposed).trim();
  }

  hasAnyProposedInList(list: any[] | null | undefined): boolean {
    return (list || []).some(
      (item: any) =>
        this.isAmendmentTypeActive(item?.type) &&
        this.hasProposedContent(item?.proposedChange)
    );
  }

  get bylaws(): FormArray {
    return this.registrationForm.get('bylaws') as FormArray;
  }

  removeBylaw(index: number): void {
    this.bylaws.removeAt(index);
    this.bylawsList.splice(index, 1);
  }
  onFileSelected(event: any, key: string) {
    const file = event?.target?.files?.[0];

    if (!file) return;

    const fileName = file.name;
    const fileExtension = this.getFileExtension(fileName)?.toLowerCase();

    if (fileExtension !== 'pdf') {
      this.toastService.showError('Invalid file type. Allowed type: PDF only.');
      event.target.value = '';
      return;
    }

    const maxSize = 4 * 1024 * 1024;

    if (file.size > maxSize) {
      this.toastService.showError('File size should be less than or equal to 4 MB.');
      event.target.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      this.uploadedFiles[key] = {
        fileName: fileName,
        content: reader.result as string
      };
    };

    reader.onerror = () => {
      this.toastService.showError('Error reading file.');
    };

    reader.readAsDataURL(file);
  }


  isImage(dataUrl: string): boolean {
    if (!dataUrl) return false;
    return dataUrl.startsWith('data:image/');
  }


  isPDF(fileUrl: string | null): boolean {
    if (!fileUrl) return false;
    return fileUrl.startsWith('data:application/pdf') || fileUrl.endsWith('.pdf');
  }
  previewFiles(file: string, modalId: string): void {
    if (!file) return;

    const blob = this.base64ToBlobs(file, "application/pdf");

    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(blob)
    );

    this.openModal(modalId);
  }
  base64ToBlobs(base64: string, type: string): Blob {
    const base64Data = base64.includes(',')
      ? base64.split(',')[1]
      : base64;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type });
  }


  previewFile(file: any): void {
    if (!file) {
      return;
    }

    // uploadedFiles stores { fileName, content } — content is data URL base64
    const content =
      typeof file === 'string' ? file : file?.content;

    if (content && typeof content === 'string' && content.startsWith('data:')) {
      // Reuse working preview (iframe modal #viewDocumentDetails)
      this.previewFiles(content, 'viewDocumentDetails');
      return;
    }

    // Saved/server path (string file name/path)
    const path =
      typeof file === 'string' ? file : file?.fileName;

    if (!path) {
      return;
    }

    const fileUrl = this.configService.getFileUrl() + path;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = path;
    link.target = '_blank';
    link.click();
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();
      document.body.classList.add('modal-open');


    }
  }
  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
      document.body.classList.remove('modal-open');

    }
  }



  selectedBylawFile: File | null = null;

  // onBylawFileSelected(event: any): void {
  //   this.selectedBylawFile = event.target.files?.[0] || null;
  // }
  onBylawFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.addressForm.patchValue({ nocFile: file });
      this.addressForm.get('nocFile')?.updateValueAndValidity();
    } else {
      this.addressForm.patchValue({ nocFile: null });
      this.addressForm.get('nocFile')?.updateValueAndValidity();
    }
  }


  base64ToBlob(base64: any, contentType = "", sliceSize = 512): Blob {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  selectedAmendmentType: string = '';
  showNOCUpload: boolean = false;

  onAmendmentTypeChange(event: any): void {
    this.selectedAmendmentType = event.target.value;

    const selected = this.AmendmentType?.find(a => a.id == this.selectedAmendmentType);
    this.showNOCUpload = selected?.name === 'Address of the Society';
  }

  submitBylaws(): void {
    if (!this.amendmentsList.length && !this.bylawsList.length) {
      this.toastService.showError('Please add at least one amendment or bylaw before submitting.');
      return;
    }

    const byLawsDetails: any[] = this.amendmentsList.map(item => ({
      Amendment: item.Amendment || '',
      Resolution: item.Resolution || '',
      ResolutionNo: item.ResolutionNo || '',
      sAmmendmentType: item.sAmmendmentType,
      sExistByLawsDetail: item.sExistByLawsDetail || '',
      sNewByLawsDetail: item.sNewByLawsDetail || '',
      NOCUpload: item.NOCUpload?.content || null,
      FormIV: this.amendmentForm.value.FileFormIV?.content || null,
      ComparativeChart: this.amendmentForm.value.FileComparativeChart?.content || null,
      AuditedAccount: this.amendmentForm.value.FileAuditedAccount?.content || null,
      ResolutionGeneralBody: this.amendmentForm.value.FileGeneralBodyResolution?.content || null,
      ResolutionExecutive: this.amendmentForm.value.FileExecutiveBodyResolution?.content || null,
      IsActive: true
    }));

    const payload = {
      iByLawsId: 0,
      iSocietyDetailsId: this.societyDetails?.iSocietyDetailsId,
      iSocietyUserID: this.societyDetails?.iSocietyUserID,
      iUserId: null,
      IsCompleted: this.amendmentForm.value.IsCompleted || false,
      FileFormIV: this.amendmentForm.value.FileFormIV?.content || null,
      FileNameFormIV: this.amendmentForm.value.FileNameFormIV || null,
      FileComparativeChart: this.amendmentForm.value.FileComparativeChart?.content || null,
      FileNameComparativeChart: this.amendmentForm.value.FileNameComparativeChart || null,
      FileAuditedAccount: this.amendmentForm.value.FileAuditedAccount?.content || null,
      FileNameAuditedAccount: this.amendmentForm.value.FileNameAuditedAccount || null,
      FileGeneralBodyResolution: this.amendmentForm.value.FileGeneralBodyResolution?.content || null,
      FileNameGeneralBodyResolution: this.amendmentForm.value.FileNameGeneralBodyResolution || null,
      FileExecutiveBodyResolution: this.amendmentForm.value.FileExecutiveBodyResolution?.content || null,
      FileNameExecutiveBodyResolution: this.amendmentForm.value.FileNameExecutiveBodyResolution || null,
      ByLawsDetails: byLawsDetails
    };

    console.log(payload)


    this.ngxUiLoaderService.start();
    // this.byLawsService.applyAmendsments2006(payload).subscribe({
    //   next: (res: any) => {
    //     this.ngxUiLoaderService.stop();
    //     if (res.status === 200) {
    //       this.toastService.showSuccess(res.message);
    //       this.router.navigate(['/bylaws']);
    //     } else {
    //       this.toastService.showError(res.message || 'Something went wrong.');
    //     }
    //   },
    //   error: (err) => {
    //     this.ngxUiLoaderService.stop();
    //     this.toastService.showError(err.message || 'Server error occurred.');
    //   }
    // });
  }

  formatLabel(value: string): string {
    if (!value) return '';

    return value
      .replace(/([A-Z])/g, ' $1')   // add space before capital letters
      .replace(/^./, str => str.toUpperCase()) // capitalize first letter
      .trim();
  }
}


